import React, { useCallback, useEffect, useState } from "react";
import {
  addLeagueFeed,
  createOrUpdateSeasonChallenge,
  getChallengeDetails,
  updateLeagueProgressStep,
} from "./firestoreQuery";
import { useNavigate, useParams } from "react-router-dom";
import MarkDownWithOption from "../ui/MarkDownWithOption";
import { DocumentData } from "firebase/firestore";
import { useAuth } from "../../contexts/AuthContext";

interface LeagueAdditionalDetailsProps {
  leagueData: {
    id: string;
    [key: string]: any;
  };
  setSelectedTab: (tab: number) => void;
  createdChallengeId?: string | null;
}

const LeagueAdditionalDetails: React.FC<LeagueAdditionalDetailsProps> = ({
  leagueData,
  setSelectedTab,
  createdChallengeId,
}) => {
  // Normalize to empty string so we never persist null/undefined
  const [additionalDetails, setAdditionalDetails] = useState<string | null>(
    null
  );
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const { challengeId } = useParams();
  const [challengeData, setChallengeData] = useState<DocumentData | null>(null);
  const user = useAuth().user;

  const getChallengeDetailsEdit = useCallback(async () => {
    try {
      // if (!challengeId) {
      //   return;
      // }
      const res = await getChallengeDetails(
        leagueData?.id,
        challengeId ?? createdChallengeId ?? ""
      );
      if (res) {
        setChallengeData(res);
        setAdditionalDetails(res.additionalDetails || "");
      }
    } catch (error) {
      console.error("Error fetching challenge details: ", error);
    }
  }, [leagueData, challengeId]);

  useEffect(() => {
    getChallengeDetailsEdit();
  }, [getChallengeDetailsEdit]);

  const handleSave = async () => {
    // if (!leagueDueDate) return;
    setSaving(true);
    const dataToSave = {
      leagueId: leagueData.id,
      challengeCreationStatus: "published",
      additionalDetails: additionalDetails ?? "",
      ...(challengeId && challengeData?.challengeCreationStatus === "published"
        ? { updatedAt: new Date().toISOString() }
        : { createdAt: new Date().toISOString() }),
    };
    console.log("Data to save:", dataToSave);
    try {
      await createOrUpdateSeasonChallenge(
        dataToSave,
        createdChallengeId ?? challengeId
      );
      // add a new post in the feed section for challenge creation
      const feedData = {
        postType: "challenge",
        challengeTitle: challengeData?.challengeTitle,
        challengeDescription: challengeData?.challengeDescription,
        challengeImageUrl: challengeData?.challengeImageUrl,
        createdBy: challengeData?.createdBy,
        createdAt: new Date().toISOString(),
        challengeId: challengeId ?? createdChallengeId,
        challengeCreationStatus: "published",
      };
      if (challengeData?.challengeCreationStatus !== "published") {
        await addLeagueFeed(leagueData.id, feedData);
        challengeData?.createdBy === user?.uid &&
          (await updateLeagueProgressStep(leagueData.id, "create-a-challenge"));
      }
      navigate(`/${leagueData.leagueUrl}`);
    } catch (err) {
      alert("Failed to save details. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="pageHeading">
        <span>Additional Details</span>
      </div>
      <div className="shadowBlk">
        <div className="formGroup">
          <label>Rules & Details</label>
          <MarkDownWithOption
            value={additionalDetails ?? ""}
            onChange={(value) => setAdditionalDetails(value ?? "")}
            placeholder="Feel free to add any rules or details about the challenge here."
            autoFocus
          />
        </div>
      </div>

      {/* <div className="formGroup">
        <label>
          Season Challenge Due Date <span className="reqTxt">Required</span>
        </label>
        <div className="smallTxt">
          ** Majority of Team Members Must Approve Challenge by
        </div>
        <input
          className="fldStyle"
          type="date"
          placeholder="MM/DD/YYYY"
          value={leagueDueDate}
          onChange={(e) => setLeagueDueDate(e.target.value)}
        />
      </div> */}

      <div className="btnWrap">
        <button
          type="button"
          className="btnStyle "
          onClick={() => setSelectedTab(2)}
        >
          CANCEL
        </button>
        <button
          type="submit"
          className="btnStyle btnFilled"
          onClick={handleSave}
          disabled={saving}
        >
          FINISH CHALLENGE
        </button>
      </div>
    </>
  );
};

export default LeagueAdditionalDetails;
